import { render, staticRenderFns } from "./DetailPc.vue?vue&type=template&id=66d9b638&scoped=true"
import script from "./DetailPc.vue?vue&type=script&lang=js"
export * from "./DetailPc.vue?vue&type=script&lang=js"
import style0 from "./DetailPc.vue?vue&type=style&index=0&id=66d9b638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d9b638",
  null
  
)

export default component.exports